/**
 * Testimonials
 */

// Vendors
import $ from 'jquery';
import carousels from '../framework/carousel';
import 'waypoints/lib/jquery.waypoints.min';

// Init carousel
$('.testimonials__carousel').each((index, element) => {
  carousels(element, {
    autoplay: false,
    dots: true,
    infinite: true,
    speed: 500,
    cssEase: 'cubic-bezier(0.770, 0.000, 0.175, 1.000)',
    prevArrow:
      '<button type="button" class="slick-arrow slick-prev module-hover-root"><span class="arrow arrow--white"></span></button>',
    nextArrow:
      '<button type="button" class="slick-arrow slick-next module-hover-root"><span class="arrow arrow--white"></span></button>',
    appendArrows: $(element)
      .closest('.testimonials')
      .find('.testimonials__nav'),
    appendDots: $(element).closest('.testimonials').find('.testimonials__nav')
  });
});

const parallax = $('.parallax');
let scrollPosition = 0;
let scrolling = false;

// handle parallax effect on background element.
function doParallax(position, element) {
  const offset = element.offset().top;
  const bottom = offset + element.outerHeight(true);

  if (position >= bottom) {
    return;
  }

  const speed = 0.25;
  const parallax = (position - offset) * speed;

  const translateY = parallax.toFixed(2);

  element.css({ transform: `translate3d(0, ${translateY}px, 0)` });
}

// only add event listener if background is present and we are not in mobile view
if (parallax.length > 0 && document.body.offsetWidth > 1200) {
  const parallaxImage = $('.parallax__image > img');
  window.addEventListener('scroll', function (e) {
    scrollPosition = $(this).scrollTop();

    if (!scrolling) {
      this.window.requestAnimationFrame(function () {
        // only call parallax function if we have reached the element

        parallax.each(
          (index, element) =>
            new Waypoint({
              element: $(element),
              offset: '100%',
              handler: (direction) => {
                if (direction !== 'down') return;

                doParallax(scrollPosition, parallaxImage);
              }
            })
        );

        scrolling = false;
      });

      scrolling = true;
    }
  });
}
